import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgSquareMinusRegular = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M15.536 11.036c.534 0 .964.43.964.964s-.43.964-.964.964H8.464A.96.96 0 0 1 7.5 12c0-.534.43-.964.964-.964zM3 5.57A2.57 2.57 0 0 1 5.571 3H18.43A2.573 2.573 0 0 1 21 5.571V18.43A2.574 2.574 0 0 1 18.429 21H5.57A2.573 2.573 0 0 1 3 18.429zm1.929 0V18.43c0 .353.287.642.642.642H18.43c.353 0 .642-.289.642-.642V5.57a.644.644 0 0 0-.642-.642H5.57a.643.643 0 0 0-.642.642"
    }));
export default SvgSquareMinusRegular;
